var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSankaku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_88_6",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 88 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1514",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1514",
    transform: "translate(-152 -1853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_13348",
    "data-name": "\\u9577\\u65B9\\u5F62 13348",
    transform: "translate(152 1853)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_228",
    "data-name": "\\u30D1\\u30B9 228",
    d: "M212.5,391.391h-32l16-27.712Zm-25.993-3.422h19.985L196.5,370.661Z",
    transform: "translate(-28.502 1491.321)",
    fill: "#41619a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankaku);
export default __webpack_public_path__ + "static/media/sankaku.ec4a1aa631fce7bf30041d03b867adac.svg";
export { ForwardRef as ReactComponent };